import { tv } from 'tailwind-variants'

export const flexibleImageStyle = tv({
  base: 'h-auto',
  variants: {
    hasWidth: { true: {} },
    isFirst: { true: {} },
    isLast: { true: {} },
    slideToEdge: { true: {} },
  },
  compoundVariants: [
    {
      hasWidth: false,
      isFirst: true,
      className: 'self-start',
    },
    {
      hasWidth: false,
      isFirst: false,
      className: 'self-end',
    },
    {
      hasWidth: false,
      isFirst: true,
      slideToEdge: true,
      className: '2xl:ml-[calc((100vw - 1440px - 16px) / -2)]',
    },
    {
      hasWidth: false,
      isFirst: false,
      slideToEdge: [true, false],
      className: '2xl:ml-0',
    },
    {
      hasWidth: false,
      isFirst: [true, false],
      slideToEdge: false,
      className: '2xl:ml-0',
    },
    {
      hasWidth: false,
      isLast: true,
      slideToEdge: true,
      className: '2xl:mr-[calc((100vw - 1440px - 16px) / -2)]',
    },
    {
      hasWidth: false,
      isLast: false,
      slideToEdge: [true, false],
      className: '2xl:mr-0',
    },
    {
      hasWidth: false,
      isLast: [true, false],
      slideToEdge: false,
      className: '2xl:mr-0',
    },
  ],
})
